import React from 'react';
import { useAppSelector } from '../../state/hooks';
import { СxSolutionStyles } from './СxSolutionStyles';
import {
  CxBestPractices,
  CxComprehensive,
  CxCrafting,
  CxDiscover,
  CxGetStarted,
  CxMethodology,
  CxSolutionIntro,
  CxSolutionPartners,
} from '../../components';
import MetaFromApi from '../../components/metaFromApi/MetaFromApi';

export const СxSolution = () => {
  const { interfaceLanguage } = useAppSelector((state) => state.languages);

  return (
    <СxSolutionStyles>
      <MetaFromApi slug="cx" />
      <CxSolutionIntro />
      <CxDiscover />
      <CxSolutionPartners />
      <CxComprehensive />
      <CxCrafting />
      <CxMethodology />
      <CxGetStarted />
      <CxBestPractices />
    </СxSolutionStyles>
  );
};
